import { render, staticRenderFns } from "./BusinessCategory.vue?vue&type=template&id=23899112"
import script from "./BusinessCategory.vue?vue&type=script&lang=js"
export * from "./BusinessCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports